import { Validators } from "@angular/forms";
import { RecipientFormConstants } from "../components/recipient-components/shared/shared-contants/recipient-shared.constants";
import { phoneNumberValidator } from "../classes/phone-number-validator";
import { isString } from "underscore";
export default class RecipientUtils {
    static mapStepMetaRecipientGroups(stepMetaGroups) {
        const groups = [];
        stepMetaGroups.map((groupObj) => {
            if (groupObj.hasOwnProperty("groupName")) {
                groups.push(groupObj);
            }
            else {
                groups.push({
                    groupName: groupObj.GroupName,
                    groupType: groupObj.GroupType,
                    requiredFields: groupObj.requiredFields
                });
            }
        });
        return groups;
    }
    static removeInvalidRecipientProperties(recipient) {
        // Checks and remove properties that cannot be mapped to the recipient Dto
        if (recipient) {
            if (recipient.hasOwnProperty("id")) {
                if (isString(recipient.id) && recipient.id.indexOf("-") >= 0) {
                    recipient.id = 0;
                }
                if (recipient.id === null) {
                    delete recipient.id;
                }
            }
            if (recipient.hasOwnProperty("jobId") &&
                recipient.jobId === null) {
                delete recipient.jobId;
            }
            if (recipient.hasOwnProperty("groupsStringArray")) {
                delete recipient.groupsStringArray;
            }
            if (recipient.hasOwnProperty("emailField")) {
                delete recipient.emailField;
            }
            if (recipient.hasOwnProperty("overrideGroup")) {
                delete recipient.overrideGroup;
            }
            if (recipient.hasOwnProperty("selected")) {
                delete recipient.selected;
            }
            if (recipient.hasOwnProperty("setRecipient")) {
                delete recipient.setRecipient;
            }
            if (recipient.hasOwnProperty("consolidatedGroup")) {
                delete recipient.consolidatedGroup;
            }
            if (recipient.hasOwnProperty("fullName")) {
                delete recipient.fullName;
            }
            if (recipient.hasOwnProperty("groupsStringArray")) {
                delete recipient.groupsStringArray;
            }
            if (recipient.hasOwnProperty("selected")) {
                delete recipient.selected;
            }
            recipient.groups.forEach(group => {
                if (group?.hasOwnProperty("requiredFields")) {
                    delete group.requiredFields;
                }
            });
        }
        return recipient;
    }
    static makeDeepCopies(recipient, overrideGroup, removeId) {
        const recipientDeepCopy = Object.assign({}, recipient);
        if (recipientDeepCopy.hasOwnProperty("id") && removeId) {
            delete recipientDeepCopy.id;
        }
        if (overrideGroup) {
            recipientDeepCopy.overrideGroup = overrideGroup;
        }
        else {
            recipientDeepCopy.groups.forEach(group => {
                if (group.hasOwnProperty("id") && removeId) {
                    delete group.id;
                }
            });
        }
        return recipientDeepCopy;
    }
    static checkAddressDetails(recipient, recipientForm) {
        // if postal details are the same as residential details returns true
        let sameAsResidential = false;
        const streetAddressValue = recipientForm.get(RecipientFormConstants.streetAddressFormControlName).value;
        const postalAddressValue = recipientForm.get(RecipientFormConstants.postalAddressFormControlName).value;
        const streetSuburbValue = recipientForm.get(RecipientFormConstants.streetSuburbFormControlName).value;
        const postalSuburbValue = recipientForm.get(RecipientFormConstants.postalSuburbFormControlName).value;
        const streetCityValue = recipientForm.get(RecipientFormConstants.streetCityFormControlName).value;
        const postalCityValue = recipientForm.get(RecipientFormConstants.postalCityFormControlName).value;
        const streetProvinceValue = recipientForm.get(RecipientFormConstants.postalProvinceFormControlName).value;
        const postalProvinceValue = recipientForm.get(RecipientFormConstants.postalProvinceFormControlName).value;
        const streetCountryValue = recipientForm.get(RecipientFormConstants.streetCountryFormControlName).value;
        const postalCountryValue = recipientForm.get(RecipientFormConstants.postalCountryFormControlName).value;
        const streetCodeValue = recipientForm.get(RecipientFormConstants.streetCodeFormControlName).value;
        const postalCodeValue = recipientForm.get(RecipientFormConstants.postalCodeFormControlName).value;
        if (((streetAddressValue !== null) && (streetAddressValue === postalAddressValue)) &&
            ((streetSuburbValue !== null) && (streetSuburbValue === postalSuburbValue)) &&
            ((streetCityValue !== null) && (streetCityValue === postalCityValue)) &&
            ((streetProvinceValue !== null) && (streetProvinceValue === postalProvinceValue)) &&
            ((streetCountryValue !== null) && (streetCountryValue === postalCountryValue)) &&
            ((streetCodeValue !== null) && (streetCodeValue === postalCodeValue))) {
            sameAsResidential = true;
        }
        else {
            sameAsResidential = false;
        }
        return sameAsResidential;
    }
    static disablePostalDetails(recipientForm) {
        // disables all fields under the 'Postal details' section
        recipientForm?.get(RecipientFormConstants.postalAddressFormControlName).disable();
        recipientForm?.get(RecipientFormConstants.postalSuburbFormControlName).disable();
        recipientForm?.get(RecipientFormConstants.postalCityFormControlName).disable();
        recipientForm?.get(RecipientFormConstants.postalProvinceFormControlName).disable();
        recipientForm?.get(RecipientFormConstants.postalCountryFormControlName).disable();
        recipientForm?.get(RecipientFormConstants.postalCodeFormControlName).disable();
    }
    static enablePostalDetails(recipientForm) {
        // enables all fields under the 'Postal details' section
        recipientForm?.get(RecipientFormConstants.postalAddressFormControlName).enable();
        recipientForm?.get(RecipientFormConstants.postalSuburbFormControlName).enable();
        recipientForm?.get(RecipientFormConstants.postalCityFormControlName).enable();
        recipientForm?.get(RecipientFormConstants.postalProvinceFormControlName).enable();
        recipientForm?.get(RecipientFormConstants.postalCountryFormControlName).enable();
        recipientForm?.get(RecipientFormConstants.postalCodeFormControlName).enable();
    }
    static restorePostalDetailsValidators(recipientFormGroup, groupsFromMetadata) {
        if (groupsFromMetadata[0].hasOwnProperty("requiredFields")) {
            const requiredFields = groupsFromMetadata[0].requiredFields;
            if (requiredFields.postalAddress || requiredFields.PostalAddress)
                recipientFormGroup.get(RecipientFormConstants.postalAddressFormControlName).setValidators(Validators.required);
            if (requiredFields.postalSuburb || requiredFields.PostalSuburb)
                recipientFormGroup.get(RecipientFormConstants.postalSuburbFormControlName).setValidators(Validators.required);
            if (requiredFields.postalCity || requiredFields.PostalCity)
                recipientFormGroup.get(RecipientFormConstants.postalCityFormControlName).setValidators(Validators.required);
            if (requiredFields.postalProvince || requiredFields.PostalProvince)
                recipientFormGroup.get(RecipientFormConstants.postalProvinceFormControlName).setValidators(Validators.required);
            if (requiredFields.postalCountry || requiredFields.PostalCountry)
                recipientFormGroup.get(RecipientFormConstants.postalCountryFormControlName).setValidators(Validators.required);
            if (requiredFields.postalCode || requiredFields.PostalCode)
                recipientFormGroup.get(RecipientFormConstants.postalCodeFormControlName).setValidators(Validators.required);
        }
    }
    static checkRequiredFields(groupsFromMetadata, newRecipientForm) {
        if (groupsFromMetadata && newRecipientForm && groupsFromMetadata.length > 0 && groupsFromMetadata[0].hasOwnProperty("requiredFields") && Object.keys(groupsFromMetadata[0].requiredFields)?.length > 0) {
            for (const [fieldName, isRequired] of Object.entries(groupsFromMetadata[0].requiredFields)) {
                const field = this.formatObjectKey(fieldName);
                if (isRequired) {
                    this.setRequiredFields(newRecipientForm, field);
                }
            }
            newRecipientForm.updateValueAndValidity();
        }
    }
    static formatObjectKey(key) {
        let keyToChange = key;
        if (keyToChange === "Homephone") {
            keyToChange = "HomePhone";
        }
        const formattedString = keyToChange.charAt(0).toLowerCase() + keyToChange.slice(1);
        return formattedString;
    }
    static setRequiredFields(recipientFormGroup, fieldName) {
        recipientFormGroup.controls[fieldName].setValidators(Validators.required);
        if (fieldName === RecipientFormConstants.homeTelePhoneFormControl) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, phoneNumberValidator]);
            return;
        }
        if (fieldName === RecipientFormConstants.workTelephoneFormControl) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, phoneNumberValidator]);
            return;
        }
        if (fieldName === RecipientFormConstants.cellphoneFormControlName) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, phoneNumberValidator]);
            return;
        }
        if (fieldName === RecipientFormConstants.streetCodeFormControlName) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, Validators.minLength(4)]);
            return;
        }
        if (fieldName === RecipientFormConstants.postalCodeFormControlName) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, Validators.minLength(4)]);
            return;
        }
        if (fieldName === RecipientFormConstants.emailFormControlName) {
            recipientFormGroup.get(fieldName).setValidators([Validators.required, Validators.email]);
            return;
        }
        recipientFormGroup.get(fieldName).setValidators(Validators.required);
    }
    static enablePostalSelects(recipientFormGroup, postalProvinceFormControlName, sameAsResidentialChecked) {
        if (sameAsResidentialChecked) {
            recipientFormGroup.get(postalProvinceFormControlName).enable();
        }
    }
    static disablePostalSelects(recipientFormGroup, postalProvinceFormControlName, sameAsResidentialChecked) {
        if (sameAsResidentialChecked) {
            recipientFormGroup.get(postalProvinceFormControlName).disable();
        }
    }
    static clearPostalDetailsValidators(recipientFormGroup, sameAsResidentialChecked) {
        // clears all validators of Postal fields then updates value and validity
        if (sameAsResidentialChecked) {
            recipientFormGroup?.get(RecipientFormConstants.postalAddressFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalSuburbFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalCityFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalProvinceFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalCountryFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalCodeFormControlName).clearValidators();
            recipientFormGroup?.get(RecipientFormConstants.postalAddressFormControlName).updateValueAndValidity();
            recipientFormGroup?.get(RecipientFormConstants.postalSuburbFormControlName).updateValueAndValidity();
            recipientFormGroup?.get(RecipientFormConstants.postalCityFormControlName).updateValueAndValidity();
            recipientFormGroup?.get(RecipientFormConstants.postalProvinceFormControlName).updateValueAndValidity();
            recipientFormGroup?.get(RecipientFormConstants.postalCountryFormControlName).updateValueAndValidity();
            recipientFormGroup?.get(RecipientFormConstants.postalCodeFormControlName).updateValueAndValidity();
        }
    }
    static copyStreetDetailsDataToPostalDetailsFields(recipientFormGroup, sameAsResidentialChecked) {
        if (sameAsResidentialChecked) {
            recipientFormGroup?.get(RecipientFormConstants.postalAddressFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetAddressFormControlName).value);
            recipientFormGroup?.get(RecipientFormConstants.postalSuburbFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetSuburbFormControlName).value);
            recipientFormGroup?.get(RecipientFormConstants.postalCityFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetCityFormControlName).value);
            recipientFormGroup?.get(RecipientFormConstants.postalProvinceFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetProvinceFormControlName).value);
            recipientFormGroup?.get(RecipientFormConstants.postalCountryFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetCountryFormControlName).value);
            recipientFormGroup?.get(RecipientFormConstants.postalCodeFormControlName).patchValue(recipientFormGroup.get(RecipientFormConstants.streetCodeFormControlName).value);
        }
    }
    static onResidentialInputEntered($event, formControlName, recipientFormGroup, sameAsResidentialChecked) {
        if (sameAsResidentialChecked) {
            const inputValue = $event.target.value;
            const postalFormControl = recipientFormGroup.get(formControlName);
            postalFormControl.patchValue(inputValue);
        }
    }
    static standardizeRecipientGroupsObject(recipientGroups) {
        // standardizes casing on the keys of the groups Object
        let standardizedRecipientGroups = [];
        if (recipientGroups && recipientGroups.length > 0) {
            standardizedRecipientGroups = recipientGroups.map((recipientGroup, index) => {
                if (index === 0) {
                    return {
                        groupType: recipientGroup.hasOwnProperty("GroupType") ? recipientGroup.GroupType : recipientGroup.groupType,
                        groupName: recipientGroup.hasOwnProperty("GroupName") ? recipientGroup.GroupName : recipientGroup.groupName,
                        requiredFields: recipientGroup.hasOwnProperty("requiredFields") ? recipientGroup.requiredFields : undefined
                    };
                }
                else {
                    return {
                        groupType: recipientGroup.hasOwnProperty("GroupType") ? recipientGroup.GroupType : recipientGroup.groupType,
                        groupName: recipientGroup.hasOwnProperty("GroupName") ? recipientGroup.GroupName : recipientGroup.groupName
                    };
                }
            });
        }
        if (!standardizedRecipientGroups[0].requiredFields)
            delete standardizedRecipientGroups[0].requiredFields;
        return standardizedRecipientGroups;
    }
    static setRecipients(recipients, overrideGroup, recipientControl, removeId = false) {
        const values = [];
        recipients.forEach(recipient => {
            const recipientDeepCopy = this.makeDeepCopies(recipient, overrideGroup, removeId);
            recipientDeepCopy.setRecipient = true;
            values.push(recipientDeepCopy);
        });
        recipientControl.setValue(values);
    }
    static cleanPropertyOwners(existingApplication) {
        // removes owner properties that are not going part of the recipient DTO
        if (existingApplication.hasOwnProperty("properties") && existingApplication.properties.length > 0) {
            existingApplication.properties.forEach((propertyItem) => {
                let owners = propertyItem.owners ? propertyItem.owners : [];
                if (owners && owners.length > 0) {
                    owners = owners.map((owner) => {
                        owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                        return owner;
                    });
                }
            });
        }
    }
}
